// extracted by mini-css-extract-plugin
export default {"container":"Integrations_container__Z0kbK"};